import React from 'react'

function Hero() {
    return ( 
        <section className='container-fluid' id='support'>
            <div className=' p-4 ' id='supportWrapper'>
                <h3>Support Portal</h3>
                <a href='#'>Track tickets</a>
            </div>
            <div className='row p-4 mt-5 mb-5'>
                <div className='col-6 p-4 '>
                    <h1 className='fs-3'>Search for an answer or browse help tickets to create a ticket</h1>
                    <input className='mt-3' placeholder='Eg. How do I activate F&O'/>
                    <br></br>
                    <a href='' className='mx-3'>Track account opening</a>
                    <a href='' className='mx-3'>Track segment activations</a>
                    <a href='' className='mx-3'>Intraday margins</a><br></br>
                    <a href='' className='mx-3'>Kite user manual</a>
                </div>   
                <div className='col-6 p-4 '>
                    <h1 className='fs-3'>Featured</h1>
                    <ol>
                        <li><a href='#'> Scheduled maintenance downtime for Coin</a></li>
                        <li><a href='#'> BSE StAR mutual fund platform downtime</a></li>
                    </ol>
                    
                    
                </div> 
            </div>
            
        </section>
     );
}

export default Hero;